'use strict';
//  Declare app level Controller
angular.module('cvsApp')
  .controller('StorelocatorController', ["$scope", "cvsAppData","$rootScope", "webTrendsService", "$timeout", function($scope, CAD,$rootScope, WTS, $timeout){
        $scope.SLMAIN = this;
    $scope.SLMAIN.reviewStore = CAD.getReviewOrder();
        $rootScope.showStoreDetailsView = false;

        var utagObj = {};
          utagObj.page_name = "Store locator";
      utagObj.page_category = "Store locator";
      $scope.triggerOnLoad = function(){
        $timeout(function(){
          WTS.webTrendsUtag("OBJ", utagObj);
      }, 1000);
      }
        try {
          if (native) {
              native.setDefaultHeader('Find a store', true, true);
              $rootScope.isNative = true;
          }
        } catch (ex) {

        }
        // if(!cvsUtility.hasOwnProperty('checkAndRedirect') || cvsUtility.checkAndRedirect() ){
        //   $scope.triggerOnLoad();
        // }
        $scope.triggerOnLoad();
  }]);